import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { getStoredData } from "../../api/fetchData.jsx";
import TableComponent from "../../components/TableComponent/TableComponent.jsx"; // ✅ Import
import "./AllTablePage.css";


const AllTablePage = () => {
  const { model } = useParams();
  const [config, setConfig] = useState(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const json = await getStoredData();
        const tableConfigs = json["1"]?.tableConfigs || {};
        if (tableConfigs[model]) {
          setConfig(tableConfigs[model]);
        } else {
          setConfig(null);
        }
      } catch (err) {
        console.error("Failed to load table config", err);
        setConfig(null);
      }
    };
    fetchConfig();
  }, [model]);

  useEffect(() => {
    if (config) {
      axios.get(config.api)
        .then((res) => {
          setData(res.data);
          setLoading(false);
        })
        .catch((err) => {
          console.error("Error fetching data", err);
          setLoading(false);
        });
    }
  }, [config]);

  if (config === null) return <div style={{ padding: 20 }}>Invalid or missing table config for "{model}"</div>;


  return (
    <div className="TablePageContainer">
      <TableComponent title = {config.title}data={data} columns={config.columns} api={config.api} model={model}/>
    </div>
  );
};

export default AllTablePage;
